import { Box, Container, Stack, styled, Typography } from '@mui/material';
import { Fragment, type ReactNode } from 'react';
import { DASHBOARD_LAYOUT_GAP_PX } from '.';
import { PageFooter } from '../Common/PageFooter';
import { PlatformNotifications } from '../Common/PlatformNotifications';

const StyledAccountDashboardMain = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'hasTopMenu',
})<{ hasTopMenu?: boolean }>`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  flex-grow: 1;
  min-height: ${({ hasTopMenu }) => (hasTopMenu ? `calc(100vh - ${DASHBOARD_LAYOUT_GAP_PX})` : '100vh')};
`;

// this component is used to render the page title and the action buttons
export const AccountDashboardMain = ({
  children,
  title,
  titleBox,
  buttons,
  hasTopMenu = true,
}: {
  children: ReactNode;
  title?: string;
  titleBox?: ReactNode;
  buttons?: ReactNode[];
  hasTopMenu?: boolean;
}) => (
  <StyledAccountDashboardMain hasTopMenu={hasTopMenu}>
    <Container maxWidth="xl" component="main" sx={{ flexGrow: 1, py: 4, px: { md: 4 } }}>
      <PlatformNotifications sx={{ mb: 2 }} />

      {(titleBox ?? title ?? Boolean(buttons?.length)) && (
        <Stack
          direction="row"
          sx={{
            justifyContent: 'space-between',
            gap: 1,
            mb: 1,
          }}
        >
          {titleBox}
          {title && <Typography variant="h5">{title}</Typography>}
          {/** show action buttons */}
          {Boolean(buttons?.length) && (
            <Stack
              direction="row"
              sx={{
                alignItems: 'center',
                flexWrap: 'wrap',
              }}
            >
              {buttons?.map((button, index) => (
                <Fragment key={index}>{button}</Fragment>
              ))}
            </Stack>
          )}
        </Stack>
      )}
      {/** page content */}
      {children}
    </Container>
    <PageFooter />
  </StyledAccountDashboardMain>
);
